export const FetchPost = async ({ url, param }) => {
    //console.log("PARAMEROS FACT ", url)
    //console.log("PARAMEROS FACT ", param)
    return await fetch(url, {
        method: "post",
        headers: { Accept: "application/json" },
        body: JSON.stringify(param)
    })
        .then(response => response.json())
        .catch(response => 'Error al consultar');
};